import {
    GET_PAYMENTS_BY_WAY_PAYMENT,
    GET_PAYMENTS_BY_CUSTOMERS,
    GET_PAYMENTS_BY_TYPE_DOCUMENTS
 } from '../constants/dashboard';
 
 export const dashboard = ( state = {}, action ) => {
    switch ( action.type ) { 
 
        case GET_PAYMENTS_BY_WAY_PAYMENT : {
            return action.payload;
        }

        case GET_PAYMENTS_BY_CUSTOMERS : {
            return action.payload;
        }

        case GET_PAYMENTS_BY_TYPE_DOCUMENTS : {
            return action.payload;
        }
  
        default :
        return state;
    }
}